import React, { useState, useEffect } from "react";
import "./Navbar.css";
import PopupModal from './PopupModal';
import Cookies from 'js-cookie';
import axios from 'axios'; // Make sure axios is installed

function Navbar() {

  const hubspotutkCookie = Cookies.get('hubspotutk');

  const menu = [
    {
      id: "menu-item-61",
      label: "OFFERINGS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35952",
          label: "Automation Strategy",
          url: "https://zinnov.com/offerings/automation-strategy/",
        },
        {
          id: "menu-item-35955",
          label: "Business Growth & Transformation",
          url: "https://zinnov.com/offerings/business-growth-transformation/",
        },
        {
          id: "menu-item-35946",
          label: "GCC Setup & Transformation",
          url: "https://zinnov.com/offerings/gcc-setup-and-transformation/",
        },
        {
          id: "menu-item-35947",
          label: "GCC Platform",
          url: "https://zinnov.com/offerings/global-coe-accelerator-platform/",
        },
        {
          id: "menu-item-1418",
          label: "Innovation Strategy",
          url: "https://zinnov.com/offerings/innovation-strategy/",
        },
        {
          id: "menu-item-35949",
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/offerings/mergers-and-acquisitions/",
        },
        {
          id: "menu-item-76090",
          label: "Partner Strategy",
          url: "https://zinnov.com/offerings/partner-strategy/",
        },
        {
          id: "menu-item-35950",
          label: "Private Equity",
          url: "https://zinnov.com/offerings/private-equity/",
        },
        {
          id: "menu-item-35951",
          label: "Technology & Market Insights",
          url: "https://zinnov.com/offerings/technology-market-insights/",
        }
      ],
    },
    {
      id: "menu-item-60",
      label: "INDUSTRIES",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35933",
          label: "Enterprise Software",
          url: "https://zinnov.com/industry/enterprise-software/",
        },
        {
          id: "menu-item-35934",
          label: "ER&D and Digital Services",
          url: "https://zinnov.com/industry/erd-and-digital-services/",
        },
       {
          id: "menu-item-35939",
          label: "Healthcare",
          url: "https://zinnov.com/industry/healthcare/",
        },
        {
          id: "menu-item-35937",
          label: "Industrial",
          url: "https://zinnov.com/industry/industrial/",
        },
        {
          id: "menu-item-35932",
          label: "Internet & Technology Platforms",
          url: "https://zinnov.com/industry/internet-technology-platforms/",
        },
        {
          id: "menu-item-35941",
          label: "Private Equity",
          url: "https://zinnov.com/industry/private-equity/",
        },
      ],
    },
    {
      id: "menu-item-62",
      label: "INSIGHTS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35263",
          label: "Automation",
          url: "https://zinnov.com/automation/",
        },
        {
          id: "menu-item-35271",
          label: "Centers of Excellence",
          url: "https://zinnov.com/centers-of-excellence/",
        },
        {
          id: "menu-item-35274",
          label: "Digital Technologies",
          url: "https://zinnov.com/digital-technologies/",
        },
        {
          id: "menu-item-35270",
          label: "Diversity & Inclusion",
          url: "https://zinnov.com/i-and-d/",
        },
        {
          id: "menu-item-35268",
          label: "Engineering R&D",
          url: "https://zinnov.com/engineering-r-and-d/",
        },
        {
          id: "menu-item-35269",
          label: "Global Talent",
          url: "https://zinnov.com/global-talent/",
        },
        {
          id: "menu-item-35265",
          label: "Innovation",
          url: "https://zinnov.com/innovation/",
        },
        {
          id: "menu-item-35273",
          label: "Leadership & Transformation",
          url: "https://zinnov.com/leadership-and-transformation/",
        },
        {
          id: "menu-item-35264",
          label: "Macro Trends",
          url: "https://zinnov.com/macro-trends/",
        },
        {
          id: "menu-item-35267",
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/mergers-and-acquisitions/",
        },
        {
          id: "menu-item-35266",
          label: "Private Equity",
          url: "https://zinnov.com/private-equity/",
        },
        {
          id: "menu-item-35272",
          label: "Strategy & Ops",
          url: "https://zinnov.com/strategy-and-ops/",
        },
        {
          id: "menu-item-47402",
          label: "View All Insights",
          url: "https://zinnov.com/insights/",
        },
        {
          id: "menu-item-56633",
          label: "THE ZINNOV PODCAST",
          url: "https://zinnov.com/podcasts/",
        },
      ],
    },
    {
      id: "menu-item-63",
      label: "ABOUT US",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35957",
          label: "Our Purpose",
          url: "https://zinnov.com/about-us/our-purpose/",
        },
        {
          id: "menu-item-35958",
          label: "Our People and Culture",
          url: "https://zinnov.com/about-us/our-people/",
        },
        {
          id: "menu-item-35959",
          label: "Our Leadership",
          url: "https://zinnov.com/about-us/our-leadership/",
        },
        {
          id: "menu-item-35960",
          label: "Advisory Board",
          url: "https://zinnov.com/about-us/advisory-board/",
        },
        {
          id: "menu-item-35961",
          label: "Awards & Recognition",
          url: "https://zinnov.com/about-us/awards-and-recognition/",
        },
        {
          id: "menu-item-35962",
          label: "Partnerships & Alliances",
          url: "https://zinnov.com/about-us/alliances-and-partnerships/",
        },
        {
          id: "menu-item-63044",
          label: "Case Studies",
          url: "https://zinnov.com/case-studies/",
        },
      ],
    },
    {
      id: "menu-item-64",
      label: "CAREERS",
      url: "#",
      subMenu: [
        {
          id: "menu-item-35984",
          label: "Why Zinnov",
          url: "https://zinnov.com/careers/",
        },
        {
          id: "menu-item-35985",
          label: "Explore Opportunities",
          url: "https://zinnov.com/careers/explore-opportunities/",
        },
        {
          id: "menu-item-111",
          label: "Our People",
          url: "/careers/our-people",
        },
        {
          id: "menu-item-112",
          label: "Life @ Zinnov",
          url: "/careers/life-at-zinnov",
        },
      ],
    },
    {
      id: "menu-item-75486",
      label: "Our Customers",
      url: "https://zinnov.com/customers/"
    },
  ];

  const sidemenu = [
    {
      label: "OFFERINGS",
      children: [
        {
          label: "AUTOMATION STRATEGY",
          url: "https://zinnov.com/offerings/automation-strategy/",
        },
        {
          label: "BUSINESS GROWTH & TRANSFORMATION",
          url: "https://zinnov.com/offerings/business-growth-transformation/",
        },
        {
          label: "GCC SETUP & TRANSFORMATION",
          url: "https://zinnov.com/offerings/gcc-setup-and-transformation/",
        },
        {
          label: "GCC PLATFORM",
          url: "https://zinnov.com/offerings/global-coe-accelerator-platform/",
        },
        {
          label: "Innovation Strategy",
          url: "https://zinnov.com/offerings/innovation-strategy/",
        },
        {
          label: "MERGERS AND ACQUISITIONS",
          url: "https://zinnov.com/offerings/mergers-and-acquisitions/",
        },
        {
          label: "PARTNER STRATEGY",
          url: "https://zinnov.com/offerings/partner-strategy/",
        },
        {
          label: "PRIVATE EQUITY",
          url: "https://zinnov.com/offerings/private-equity/",
        },
        {
          label: "TECHNOLOGY & MARKET INSIGHTS",
          url: "https://zinnov.com/offerings/technology-market-insights/",
        },
      ],
    },
    {
      label: "INDUSTRIES",
      children: [
        {
          label: "Enterprise Software",
          url: "https://zinnov.com/industry/enterprise-software/",
        },
        {
          label: "ER&D and Digital Services",
          url: "https://zinnov.com/industry/erd-and-digital-services/",
        },
        {
          label: "Healthcare",
          url: "https://zinnov.com/industry/healthcare/",
        },
        {
          label: "Industrial",
          url: "https://zinnov.com/industry/industrial/",
        },
        {
          label: "Internet & Technology Platforms",
          url: "https://zinnov.com/industry/internet-technology-platforms/",
        },
        {
          label: "Private Equity",
          url: "https://zinnov.com/industry/private-equity/",
        },
      ],
    },
    {
      label: "INSIGHTS",
      children: [
        {
          label: "Automation",
          url: "https://zinnov.com/automation/",
        },
        {
          label: "Centers of Excellence",
          url: "https://zinnov.com/centers-of-excellence/",
        },
        {
          label: "Digital Technologies",
          url: "https://zinnov.com/digital-technologies/",
        },
        {
          label: "Diversity & Inclusion",
          url: "https://zinnov.com/i-and-d/",
        },
        {
          label: "Engineering R&D",
          url: "https://zinnov.com/engineering-r-and-d/",
        },
        {
          label: "Global Talent",
          url: "https://zinnov.com/global-talent/",
        },
        {
          label: "Innovation",
          url: "https://zinnov.com/innovation/",
        },
        {
          label: "Leadership & Transformation",
          url: "https://zinnov.com/leadership-and-transformation/",
        },
        {
          label: "Macro Trends",
          url: "https://zinnov.com/macro-trends/",
        },
        {
          label: "Mergers & Acquisitions",
          url: "https://zinnov.com/mergers-and-acquisitions/",
        },
        {
          label: "Private Equity",
          url: "https://zinnov.com/private-equity/",
        },
        {
          label: "Strategy & Ops",
          url: "https://zinnov.com/strategy-and-ops/",
        },
        {
          label: "VIEW ALL INSIGHTS",
          url: "https://zinnov.com/insights/",
        },
        {
          label: "THE ZINNOV PODCAST",
          url: "https://zinnov.com/podcasts/",
        },
      ],
    },
    {
      label: "ABOUT US",
      children: [
        {
          label: "OUR PURPOSE",
          url: "https://zinnov.com/about-us/our-purpose/",
        },
        {
          label: "OUR PEOPLE AND CULTURE",
          url: "https://zinnov.com/about-us/our-people/",
        },
        {
          label: "OUR LEADERSHIP",
          url: "https://zinnov.com/about-us/our-leadership/",
        },
        {
          label: "ADVISORY BOARD",
          url: "https://zinnov.com/about-us/advisory-board/",
        },
        {
          label: "AWARDS & RECOGNITIONS",
          url: "https://zinnov.com/about-us/awards-and-recognition/",
        },
        {
          label: "PARTNERSHIPS & ALLIANCES",
          url: "https://zinnov.com/about-us/alliances-and-partnerships/",
        },
        {
          label: "CASE STUDIES",
          url: "https://zinnov.com/case-studies/",
        },
      ],
    },
    {
      label: "CAREERS",
      children: [
        {
          label: "WHY ZINNOV",
          url: "https://zinnov.com/careers/",
        },
        {
          label: "EXPLORE OPPORTUNITIES",
          url: "https://zinnov.com/careers/explore-opportunities/",
        },
        {
          label: "OUR PEOPLE",
          url: "/careers/#hear-from-our-people",
        },
        {
          label: "LIFE @ ZINNOV",
          url: "/careers/#life-at-zinnov",
        },
      ],
    },
    {
      label: "OUR CUSTOMERS",
      url: "https://zinnov.com/customers/",
      children: [],
    },
    {
      label: "NEWSROOM / MEDIA",
      url: "https://zinnov.com/about-us/news-media/",
      children: [],
    },
    {
      label: "CONTACT US",
      url: "https://zinnov.com/contact-us/",
      children: [],
    },
  ];

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [openIndex, setOpenIndex] = useState(null);
  const [openSideMenu, setOpenSideMenu] = useState(false);
  const [hoveredMenu, setHoveredMenu] = useState(null);
  const [searchActive, setSearchActive] = useState(false);

  const [bgColor, setBgColor] = useState("transparent");

  useEffect(() => {
    const handleScroll = () => {
      const scrollPosition = window.scrollY;

      // Change color after scrolling 100px
      if (scrollPosition > 200) {
        setBgColor("#292929");
      } else {
        setBgColor("transparent");
      }
    };

    window.addEventListener("scroll", handleScroll);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const openClosePopUp = () => {
    setIsPopupOpen(prev => !prev);
  };  

  const handleSearchClick = () => {
    setSearchActive(true);
  };

  const handleCloseSearch = () => {
    setSearchActive(false);
  };

  // const toggleMenu = (index) => {
  //     // setOpenIndex(openIndex === index ? null : index);
  //     setOpenSideMenu(false);
  // };

  const toggleSideMenu = () => {
    setOpenSideMenu(!openSideMenu);
    setOpenIndex(null);
  };

  const toggleMenu = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const handleMouseEnter = () => {
    setHoveredMenu(true);
  };

  // Function to handle mouse leave event on sidebar menu
  const handleMouseLeave = () => {
    setHoveredMenu(false);
    setOpenSideMenu(false); // Close sidebar menu when mouse leaves
  };

  const [formData, setFormData] = useState({
      firstname: '',
      lastname: '',
      company: '',
      jobtitle: '',
      email: '',
      query: '',
      message: '',
      subscribe_to_zinnov_newsletter: ''
  });
  const [errors, setErrors] = useState({});

  const validate = () => {

      let newErrors = {};
      if (!formData.firstname) newErrors.firstname = 'First Name is required';
      if (!formData.lastname) newErrors.lastname = 'Last Name is required';
      if (!formData.company) newErrors.company = 'Company is required';
      if (!formData.jobtitle) newErrors.jobtitle = 'Job Title is required';
      if (!formData.email) newErrors.email = 'Email is required';
      if (formData.email && !/\S+@\S+\.\S+/.test(formData.email)) newErrors.email = 'Email address is invalid';
      if (!formData.query) newErrors.query = 'Query is required';
      if (!formData.message) newErrors.message = 'Message is required';
      setErrors(newErrors);
      return Object.keys(newErrors).length === 0;
  };

  //console.log('Form data submitted:', formData);

  const handleChange = (e) => {
      // console.log('Testing On Change');
      const { id, value } = e.target;
      setFormData({ ...formData, [id]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    // console.log('Testing On Submit');

    const searchParams = new URLSearchParams(window.location.search);
    const utm_source = (!(searchParams.get('utm_source'))?'na':searchParams.get('utm_source'));
    const utm_campaign = (!(searchParams.get('utm_campaign'))?'na':searchParams.get('utm_campaign'));
    const utm_medium = (!(searchParams.get('utm_medium'))?'na':searchParams.get('utm_medium'));
    const utm_term = (!(searchParams.get('utm_term'))?'na':searchParams.get('utm_term'));
    const utm_content = (!(searchParams.get('utm_content'))?'na':searchParams.get('utm_content'));
    const hubspotutkCookie = Cookies.get('hubspotutk');

    if (validate()) {

        // Form submission logic 
        // console.log('Form submitted:', formData);

        const firstname = formData.firstname;
        const lastname = formData.lastname;
        const email = formData.email;
        const query = formData.query;
        const message = formData.message;

        // console.log("First Name "+firstname);
        // console.log("Last Name "+lastname);
        // console.log("UTM Source "+utm_source);
        // console.log("UTM Medium "+utm_medium);
        // console.log("UTM Campaign "+utm_campaign);

        var data = {
          "submittedAt": Date.now(),
          "fields": [
            {
              "objectTypeId": "0-1",
              "name": "firstname",
              "value": firstname
            },
            ...(lastname ? [{ objectTypeId: '0-1', name: 'lastname', value: lastname }] : []),
            {
              "objectTypeId": "0-1",
              "name": "email",
              "value": email
            },
            {
              "objectTypeId": "0-1",
              "name": "query",
              "value": query
            },
            {
              "objectTypeId": "0-1",
              "name": "message",
              "value": message
            },
            {
              "objectTypeId": "0-1",
              "name": "page_url",
              "value": window.location.href
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_campaign",
              "value": utm_campaign
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_content",
              "value": utm_content
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_medium",
              "value": utm_medium
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_source",
              "value": utm_source
            },
            {
              "objectTypeId": "0-1",
              "name": "utm_term",
              "value": utm_term
            }
          ],
          "context": {
                "hutk": hubspotutkCookie, // include this parameter and set it to the hubspotutk cookie value to enable cookie tracking on your submission
                "pageUri": window.location.href,
                "pageName": document.getElementsByTagName("title")[0].innerHTML
           }
        }
      
          var final_data = JSON.stringify(data);

        axios.post('https://zinnov.com/centers-of-excellence/why-set-up-global-capability-centers-in-india-blog/api/contact_form.php', final_data)
            .then(response => {
                // console.log('Form data submitted:', response.data);
                window.location.href = 'https://zinnov.com/contact-us/thank-you/';
            })
            .catch(error => {
                // console.error('Error submitting form data:', error);
            });

        //formv3(firstName,lastName,formData.email,formData.message,utm_campaign,utm_medium,utm_source,utm_term,utm_content);
        //navigate('/thank-you',{state: {firstName: firstName, lastName: lastName, email: formData.email, utm_campaign: utm_campaign, utm_medium: utm_medium, utm_source: utm_source, utm_term: utm_term, utm_content: utm_content,whichform: 'contact form'}});

        // Clear form data
        setFormData({
          firstname: '',
          lastname: '',
          company: '',
          jobtitle: '',
          email: '',
          query: '',
          message: '',
          subscribe_to_zinnov_newsletter: ''
        });
        // Clear errors
        setErrors({});
        setIsPopupOpen(false); // Close the popup after submission

    }
    
  };

  return (
    <div id="nav-bar">
      <div id="container-menus" style={{ backgroundColor: bgColor }}>
        <nav role="navigation" id="secondary-menu" class="secondary-menu">
          <div class="header-menu-class">
            <ul
              id="menu-secondary-menu"
              class="menu"
              style={{ transform: "none" }}
            >
              <li
                id="menu-item-37499"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-37499"
              >
                <a href="https://zinnov.com/about-us/news-media/">
                  NEWSROOM / MEDIA
                </a>
              </li>
              <li
                id="menu-item-63122"
                class="menu-item menu-item-type-post_type menu-item-object-page menu-item-63122"
              >
                <a href="https://zinnov.com/contact-us/">CONTACT US</a>
              </li>
            </ul>
          </div>
        </nav>
        <nav role="navigation" id="main-menu" className="main-menu">
          <div className="header-menu-class">
            <ul id="menu-header" className="menu">
            {menu.map((item, index) => (
              <li
                key={item.id}
                className={`menu-item menu-item-type-custom menu-item-object-custom ${item.subMenu ? 'menu-item-has-children' : ''}`}
                onMouseEnter={() => setHoveredMenu(index)}
                onMouseLeave={() => setHoveredMenu(null)}
              >
                {item.subMenu && item.subMenu.length > 0 ? (
                  <>
                    <a role="button">{item.label}</a>
                    {hoveredMenu === index && (
                      <ul className="sub-menu">
                        {item.subMenu.map((subItem) => (
                          <li
                            key={subItem.id}
                            className="menu-item menu-item-type-post_type menu-item-object-page"
                          >
                            <a href={subItem.url}>{subItem.label}</a>
                          </li>
                        ))}
                      </ul>
                    )}
                  </>
                ) : (
                  <a href={item.url}>{item.label}</a>
                )}
              </li>
            ))}
          </ul>
          </div>

          <div id="sandwich-menu">
            {!openSideMenu ? (
              <div id="menuToggle" onClick={toggleSideMenu}>
                <span></span>
                <span></span>
                <span></span>
              </div>
            ) : (
              <div id="menuToggle-close" onClick={toggleSideMenu}>
                <span></span>
              </div>
            )}

            {openSideMenu && (
              <div
                className="header-menu-colpased-class"
                onMouseEnter={handleMouseEnter}
                onMouseLeave={handleMouseLeave}
              >
               <ul id="menu-sandwich-menu" className="menu">
                {sidemenu.map((item) => (
                  <li
                    key={item.id}
                    className={`menu-item menu-item-type-custom menu-item-object-custom ${
                      item.children && item.children.length > 0 ? "menu-item-has-children" : ""
                    }`}
                  >
                    {item.children && item.children.length > 0 ? (
                      <>
                        <a role="button">{item.label}</a>
                        <ul className="sub-menu">
                          {item.children.map((listitems) => (
                            <li
                              key={listitems.id}
                              className="menu-item menu-item-type-post_type menu-item-object-page"
                            >
                              <a href={listitems.url}>{listitems.label}</a>
                            </li>
                          ))}
                        </ul>
                      </>
                    ) : (
                      <a href={item.url}>{item.label}</a>
                    )}
                  </li>
                ))}
              </ul>
                <div className="sandwich-menu-social-icons">
                  <a
                    href="https://www.linkedin.com/company/zinnov"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/linkedin.png"
                      alt="LinkedIn"
                    />
                  </a>
                  <a
                    href="https://www.facebook.com/ZinnovManagementConsulting"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/facebook.png"
                      alt="Facebook"
                    />
                  </a>
                  <a href="https://twitter.com/zinnov" target="_self">
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/twitter.png"
                      alt="Twitter"
                    />
                  </a>
                  <a
                    href="https://www.youtube.com/c/ZinnovManagementConsulting"
                    target="_self"
                  >
                    <img
                      className="img-social-media"
                      src="https://zinnov.com/wp-content/themes/zinnov/assets/youtube.png"
                      alt="Youtube"
                    />
                  </a>
                </div>
              </div>
            )}
          </div>

          <div class="zinnovlogo">
            <div class="zinnovlogo-wrapper">
              <a href="https://zinnov.com">
                <img
                  src="https://zinnov.com/wp-content/themes/zinnov/images/zinnov-home.svg"
                  alt="Zinnov"
                />
              </a>
            </div>
          </div>

          <div
            role="search"
            id="search-menu"
            className={searchActive ? "open-search-menu" : ""}
          >
            <div   onClick={openClosePopUp}
              className={`header-sticky-contact-us ${
                searchActive ? "hide-contact-us" : ""
              }`}
              
            >
              <img
                class="header-sticky-contact-us-icon"
                src="https://zinnov.com/wp-content/themes/zinnov/assets/contact-us.png"
                alt="Contact us"
              />
            </div>

            <form
              id="searchform"
              action="https://zinnov.com/search-results"
              method="POST"
            >
              {!searchActive ? (
                <img
                  id="search-menu-icon"
                  height="28"
                  width="28"
                  src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/search.svg"
                  alt="Search icon"
                  onClick={handleSearchClick}
                />
              ) : (
                <>
                  <img
                    id="search-menu-icon"
                    height="28"
                    width="28"
                    src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/search.svg"
                    alt="Search icon"
                    onClick={handleSearchClick}
                  />
                  <input
                    id="search-menu-input"
                    name="q"
                    autoFocus
                    type="text"
                    required
                    style={{ display: "inline-block" }}
                  />
                  <img
                    id="simple-x-icon"
                    height="12"
                    width="12"
                    src="https://zinnov.com/wp-content/themes/zinnov/assets/icons/close.svg"
                    alt="Close icon"
                    style={{ display: "block" }}
                    onClick={handleCloseSearch}
                  />
                </>
              )}
            </form>
          </div>

        </nav>
      </div>
      <PopupModal isOpen={isPopupOpen} onClose={openClosePopUp} onSubmit={handleSubmit} onChange={handleChange} formData={formData} />

    </div>
  );
}

export default Navbar;
